"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');



var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _typed = require('shared/hooks/typed');
var _translation = require('shared/selectors/translation');

/* After a new patient message, how long to wait before asking again when
 * the answer has no pill yet: the server labels the message's language
 * within about a second of saving it, best effort. */
 const PILL_RETRY_DELAYS_MS = [1500, 4000] ; exports.PILL_RETRY_DELAYS_MS = PILL_RETRY_DELAYS_MS

/* Keeps an open patient chat's translation state fresh: fetched when the
 * chat opens and again when a new patient message arrives (the server
 * decides whether the "Not English · Translate?" pill shows, and asked too early it
 * can't tell yet, so a new message is retried twice while the pill could
 * still appear). While mounted, the chat counts as open, so pushes from
 * other staff (ConversationTranslationChanged, in the websocket listener)
 * refetch it. Does nothing for chats that can't be translated. */
 const useConversationTranslationSync = (
  conversationKey,
  isPatientChat,
) => {
  const latestPatientMessageKey = _typed.useAppSelector.call(void 0, state => conversationKey
    ? _translation.selectLatestPatientMessageKey.call(void 0, state, conversationKey)
    : undefined)
  // The newest patient message this chat was last fetched for.
  const fetchedFor = _react.useRef(null)

  _react.useEffect.call(void 0, () => {
    if (!conversationKey || !isPatientChat) return
    _actions2.default.openConversationTranslation(conversationKey)
    return () => _actions2.default.closeConversationTranslation(conversationKey)
  }, [conversationKey, isPatientChat])

  _react.useEffect.call(void 0, () => {
    if (!conversationKey || !isPatientChat) return
    const previous = fetchedFor.current
    fetchedFor.current = { conversationKey, messageKey: latestPatientMessageKey }
    const isNewMessage = _optionalChain([previous, 'optionalAccess', _ => _.conversationKey]) === conversationKey &&
      !!latestPatientMessageKey && previous.messageKey !== latestPatientMessageKey

    let cancelled = false
    let retryTimer
    const fetchState = (retriesLeft) => {
      _actions2.default.getConversationTranslation({ ConversationKey: conversationKey })
        .then((state) => {
          const [delay, ...later] = retriesLeft
          if (cancelled || delay === undefined || !_translation.couldPillStillAppear.call(void 0, state)) return
          retryTimer = setTimeout(() => fetchState(later), delay)
        })
        // A failure only hides the translation controls; nothing to report.
        .catch(() => undefined)
    }
    fetchState(isNewMessage ? exports.PILL_RETRY_DELAYS_MS : [])

    // A newer message, another chat or unmounting cancels pending retries.
    return () => {
      cancelled = true
      clearTimeout(retryTimer)
    }
  }, [conversationKey, isPatientChat, latestPatientMessageKey])
}; exports.useConversationTranslationSync = useConversationTranslationSync
